import type {PropsWithChildren} from 'react';
import React from 'react';
import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import {Card} from 'components/card';

const cardSx: SxProps = {m: 0, mb: 1, pb: 1};

export const ManifestationSubPanelCard: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const {colors} = useTheme();

  if (!children) {
    return null;
  }

  if (Array.isArray(children) && !children.length) {
    return null;
  }

  return (
    <Card colorx={colors.offWhite} sx={cardSx}>
      <Card.Content>{children}</Card.Content>
    </Card>
  );
};
